import TileOptionImage from '@ui/tiles/TileOption/TileOptionImage'
import TileOptionDebug from 'features/debug/components/TileOptionDebug'
import PricePackage from '@order/PricePackage'
import { useTranslation } from 'react-i18next'
import { getCTA, useGetLabel } from '@order/steps/helpers'
import { OptionProps } from '@order/steps/templates/Default/Option/OptionDefault'
import { useDealDimensions } from '@screens/intro/deals/Deal'

export default function OptionImageTile({ options, ...props }: OptionProps) {
  const { t } = useTranslation()

  const {
    title,
    desc,
    label,
    image,
    price,
    name,
    pricePrefix,
    priceSuffix,
    recommended,
    onPress,
    colorOption,
    value,
    id,
    // colors,
    cta,
    variantId,
    magicGlow,
    isRecommended,
  } = props

  const _label = useGetLabel({ label, price, recommended })
  const _cta = getCTA(cta)
  const priceText = _cta ? t(_cta) : undefined

  const { width, height, borderRadius } = useDealDimensions(2, 32)

  const tileOptionProps = {
    name,
    value,
    id,
    variantId,
    title,
  }

  return (
    <TileOptionImage
      {...tileOptionProps}
      desc={desc || undefined}
      label={_label}
      onPress={onPress}
      image={image}
      isRecommended={isRecommended || magicGlow}
      blurMode="backdropFilter"
      width={width}
      height={height}
      borderRadius={borderRadius}
      debugContent={<TileOptionDebug item={tileOptionProps} />}
      cta={
        <PricePackage
          price={price}
          prefix={pricePrefix}
          suffix={priceSuffix}
          text={priceText}
          colorOption={colorOption}
        />
      }
    />
  )
}
